export default "__VITE_ASSET__hcKzbjmh__"